import React from "react";
import { Plus, Star } from "lucide-react";
import Button from "components/button";
import UseContext from "hooks/useContext";

/** Empty private pool, before any search: pushes towards the first candidate. */
const PrivatePoolEmpty = ({ onAdd }) => {
    const { language } = UseContext();
    const label = (key, defaultValue) => language.getValue(`privatePool.empty.${key}`, defaultValue);

    return (
        <div className="flex flex-col items-center gap-4 rounded-lg border border-gray-200 px-6 py-10 text-center">
            <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-100">
                <Star size={28} color="#9CA3AF" aria-hidden="true" />
            </div>
            <div className="flex max-w-[360px] flex-col gap-1">
                <p className="ft-b font-medium text-gray-900">{label("title", "Votre vivier privé est vide")}</p>
                <p className="ft-sm text-gray-500">
                    {label(
                        "description",
                        "Ajoutez un candidat avec son nom et son téléphone ou son e-mail pour l'inviter sur vos missions."
                    )}
                </p>
            </div>
            <Button size="SM" className="h-10 w-full max-w-[272px]" onClick={onAdd}>
                <Plus size={18} aria-hidden="true" />
                {label("addCandidate", "Ajouter un candidat")}
            </Button>
        </div>
    );
};

export default PrivatePoolEmpty;
